import { Layers } from '@/shared/legacy/lib/layers/layers.ts';

const layersStack = new Layers(window);

window.layers = layersStack;

export default layersStack;
